var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"letter-sending justify-between flex flex-row"},[_c('Letters')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }